import { Tooltip } from '@mui/material';
import { groupMeta, theme } from '../constants';
import { ArrowRightIcon, DeviceGlyph } from './Icons';

const Slot = ({ title, subtitle, filled }) => (
  <div style={{ minWidth: 0, flex: 1 }}>
    <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: 0.4, textTransform: 'uppercase', color: theme.textFaint }}>
      {title}
    </div>
    <div
      style={{
        fontSize: 13,
        fontWeight: filled ? 700 : 500,
        color: filled ? theme.text : theme.textFaint,
        marginTop: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {subtitle}
    </div>
  </div>
);

/**
 * Sticky review strip: what is moving, where it lands, and the commit button.
 * `blockedReason` is surfaced in a tooltip so a disabled button is never silent.
 */
function MoveActionBar({ devices, fromHouseName, toHouseName, canMove, blockedReason, onMove }) {
  const count = devices?.length || 0;
  const soloDevice = count === 1 ? devices[0] : null;
  const meta = soloDevice ? groupMeta(soloDevice.groupKey) : null;

  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        marginTop: 18,
        display: 'flex',
        alignItems: 'center',
        gap: 18,
        flexWrap: 'wrap',
        padding: '14px 18px',
        borderRadius: 12,
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        boxShadow: '0 -2px 14px rgba(17,24,39,0.06)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 280 }}>
        <Slot title="From" subtitle={fromHouseName || 'Not selected'} filled={!!fromHouseName} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {soloDevice ? (
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                padding: '6px 11px',
                borderRadius: 999,
                background: meta.bg,
                color: meta.color,
                fontSize: 12.5,
                fontWeight: 700,
                maxWidth: 220,
              }}
            >
              <DeviceGlyph groupKey={soloDevice.groupKey} size={14} />
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {soloDevice.name}
              </span>
            </span>
          ) : count > 1 ? (
            <span
              style={{
                padding: '6px 11px',
                borderRadius: 999,
                background: theme.accentSoft,
                color: theme.accent,
                fontSize: 12.5,
                fontWeight: 700,
                whiteSpace: 'nowrap',
              }}
            >
              {count} devices selected
            </span>
          ) : (
            <span
              style={{
                padding: '6px 11px',
                borderRadius: 999,
                border: `1px dashed ${theme.border}`,
                color: theme.textFaint,
                fontSize: 12.5,
                fontWeight: 600,
              }}
            >
              No device selected
            </span>
          )}
          <span style={{ color: canMove ? theme.accent : theme.border, display: 'flex' }}>
            <ArrowRightIcon size={17} />
          </span>
        </div>

        <Slot title="To" subtitle={toHouseName || 'Not selected'} filled={!!toHouseName} />
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title={!canMove && blockedReason ? blockedReason : ''} placement="top" arrow>
          <span>
            <button
              onClick={onMove}
              disabled={!canMove}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '9px 22px',
                border: 'none',
                borderRadius: 8,
                background: canMove ? 'rgba(32,80,255,0.9)' : '#c7cede',
                color: '#fff',
                cursor: canMove ? 'pointer' : 'not-allowed',
                fontFamily: theme.font,
                fontSize: 13,
                fontWeight: 700,
                transition: 'background 0.2s',
              }}
            >
              {count > 1 ? `Move ${count} Devices` : 'Move Device'}
              <ArrowRightIcon size={15} />
            </button>
          </span>
        </Tooltip>
      </div>
    </div>
  );
}

export default MoveActionBar;
